var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('student-quiz-toolbar',{attrs:{"is-lang-switcher":false,"color":"orange darken-2"},on:{"toggleDrawer":function($event){_vm.drawerApp = !_vm.drawerApp}}}),_c('v-content',[_c('router-view')],1),_c('snack-displayer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }